import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EntCtx = createContext(null);

export function EntitlementsProvider({ children }) {
  const { user } = useAuth();
  const [ent, setEnt] = useState(null);

  const refresh = useCallback(async () => {
    if (!user || user === false) {
      setEnt(null);
      return;
    }
    try {
      const { data } = await api.get("/entitlements");
      setEnt(data);
    } catch {
      setEnt(null);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const flag = useCallback(
    (key) => {
      if (!ent) return false;
      // Super admins get every flag on
      if (ent.plan && ent.plan.id === "super_admin") return true;
      const flags = (ent.plan && ent.plan.feature_flags) || {};
      return !!flags[key];
    },
    [ent]
  );

  const getLimit = useCallback(
    (key, fallback = null) => {
      if (!ent || !ent.plan) return fallback;
      if (ent.plan.id === "super_admin") return Infinity;
      const v = ent.plan[key];
      return (v === undefined || v === null) ? fallback : v;
    },
    [ent]
  );

  return (
    <EntCtx.Provider value={{ ent, refresh, flag, getLimit }}>{children}</EntCtx.Provider>
  );
}

export function useEntitlements() {
  const ctx = useContext(EntCtx);
  return ctx || { ent: null, refresh: () => {}, flag: () => false, getLimit: () => null };
}
